   
<template>
    <div class="d-flex flex-column gap-3">
        <vue-upload-images :max="20" :id="`${house_id}`" />
        <br/>
        <upload-floor-plan :max="20" :id="`${house_id}`" />
    </div>
</template>

<script>
import router from '@/router'
import {
    BListGroupItem, BAvatar, BRow, BCol, BCardText, BImg, BFormCheckbox, BButton,BMedia,BMediaAside,BMediaBody,BFormFile,
    BLink
} from 'bootstrap-vue'
import draggable from 'vuedraggable'
import Prism from 'vue-prism-component'
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'
import Ripple from 'vue-ripple-directive'
import VueUploadImages from './UploadImage.vue'
import UploadFloorPlan from './UploadFloorPlan.vue'

export default {
    components: {
        BAvatar, BListGroupItem, BRow, BCol, Prism, draggable, BCardText, BImg, BFormCheckbox, BButton,
        BMedia,BMediaAside,BMediaBody, BFormFile, BLink, VueUploadImages, UploadFloorPlan,
    },
    data() {
        return {
            house_id: router.currentRoute.params.id,
            lists: [],
            input:{
                userFile:[]
            },
            options: {
                handle: '.handle'
            }
        }
    },
    directives: {
        Ripple,
    },
}
</script>

<style>
.list-group-item {
  transition: all 1s
}
</style>